import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

export default function IncompleteQuickEvaluationDialog({ open, count, onReturn, onSubmit }) {
  return <Dialog open={open} onClose={onReturn} maxWidth="xs" fullWidth>
    <DialogTitle>Seçilmemiş öğrenciler var</DialogTitle>
    <DialogContent>
      <Typography>{count} öğrencinin ödev durumu seçilmedi. Bu öğrenciler değerlendirilmeden devam edilsin mi?</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>Devamsız öğrenciler yalnızca ayrıca durumları seçildiyse değerlendirmeye alınır.</Typography>
    </DialogContent>
    <DialogActions sx={{ flexWrap: 'wrap', gap: 1, '& button': { minHeight: 44 } }}>
      <Button onClick={onReturn}>Değerlendirmeye Dön</Button>
      <Button variant="contained" onClick={onSubmit}>Yine de Kaydet ve Gönder</Button>
    </DialogActions>
  </Dialog>;
}
